import { RequestState } from "vuex-fetch-factory";
import { OrganisationModel } from "modules/relationprofile/models";
import { PrivatePersonModel } from "../models/privatePerson";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  organisation: OrganisationModel;
  privatePerson: PrivatePersonModel;
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  organisation: new OrganisationModel(),
  privatePerson: new PrivatePersonModel()
};

export default state;
